import React from "react";
import { Button, Dialog } from "@sscs/ui";
import { GroupFormPercentageSlider } from "../../types";
import GroupDialogForm from "../GroupDialogForm/GroupDialogForm";
import useAddGroupForm from "./useAddGroupForm";

const filestreamPercentageFieldName: keyof GroupFormPercentageSlider =
  "filestream_percentage";
const projectsPercentageFieldName: keyof GroupFormPercentageSlider =
  "projects_percentage";

type AddGroupProps = {
  isOpen: boolean;
  showSSOGroupMapping: boolean;
  onClose: () => void;
  totalPortalCapacity?: number;
};

const AddGroupContent = ({
  onClose,
  showSSOGroupMapping = false,
  totalPortalCapacity,
}: Omit<AddGroupProps, "isOpen">): React.JSX.Element => {
  const {
    onSubmit,
    errors,
    formMethods,
    filestreamPercentage,
    projectsPercentage,
    onPercentageSliderChange,
    onProjectsPercentageInputChange,
  } = useAddGroupForm({
    filestreamPercentageFieldName,
    projectsPercentageFieldName,
    onClose,
    totalPortalCapacity,
  });

  return (
    <GroupDialogForm
      totalPortalCapacity={totalPortalCapacity}
      onClose={onClose}
      showSSOGroupMapping={showSSOGroupMapping}
      onSubmit={onSubmit}
      errors={errors}
      formMethods={formMethods}
      title="Add group"
      filestreamPercentageFieldName={filestreamPercentageFieldName}
      projectsPercentageFieldName={projectsPercentageFieldName}
      filestreamPercentage={filestreamPercentage}
      projectsPercentage={projectsPercentage}
      onPercentageSliderChange={onPercentageSliderChange}
      onProjectsPercentageInputChange={onProjectsPercentageInputChange}
      submitButton={
        <Button type="submit" color="primary">
          Add group
        </Button>
      }
    />
  );
};

const AddGroup = ({ isOpen, ...props }: AddGroupProps): React.JSX.Element => (
  <Dialog.Frame size="md" isOpen={isOpen} onClose={props.onClose}>
    <AddGroupContent {...props} />
  </Dialog.Frame>
);

export default AddGroup;
